<template>
  <el-table
    ref="table"
    v-loading="loading"
    :show-header="showHeader"
    :data="tableData"
    :row-key="rowKey"
    :row-class-name="tableRowClassName"
    :header-cell-class-name="headerCellClassName"
    border
    fit
    :highlight-current-row="highlightCurrentRow"
    tooltip-effect="dark"
    style="width: 100%"
    :height="realHeight"
    :max-height="realMaxHeight"
    :header-cell-style="{ 'text-align': 'center' }"
    @sort-change="handleSortChange"
    @select="handleSelect"
    @selection-change="handleSelectionChange"
    @select-all="handleSelectAll"
    @row-click="handleRowClick"
  >
    <!-- <div v-for="(item) in tableLabel"  :key="item.label">
            <el-table-column v-if="item.type" :type="item.type?item.type:''" :fixed="item.fixed?item.fixed:false"></el-table-column>
            <el-table-column v-else :width="item.width ? item.width : ''" :fixed="item.fixed?item.fixed:false"  :align="item.align" :label="item.label" :prop="item.param" :sortable="item.sortable ? 'custom' : false">
                   <template slot-scope="scope">
                       <slot v-if="item.slot" :scope="scope" :name="item.slot"></slot>
                       <div v-html="item.render(scope.row)" v-else-if="item.render"> -->
    <!-- {{item.render(scope.row)}} -->
    <!-- </div>
                      <span v-else>{{scope.row[item.param]}} {{item.type}}</span>
                  </template>
            </el-table-column>
        </div> -->
    <!--多选列-->
    <el-table-column
      v-if="selectionShow"
      type="selection"
      width="50"
      align="center"
      :highlight-current-row="highlightCurrentRow"
      fixed
      :reserve-selection="reserveSelection"
      :selectable="handleCheckSelectable"
    ></el-table-column>
    <el-table-column
      v-if="indexShow"
      :fixed="fixedIndex"
      label="序号"
      type="index"
      align="center"
      width="60"
    ></el-table-column>
    <el-table-column
      v-for="(item, index) in tableLabel"
      v-show="index == 1"
      :key="index"
      :width="item.width ? item.width : ''"
      :fixed="item.fixed ? item.fixed : false"
      :type="item.type ? item.type : ''"
      :align="item.align"
      :label="item.label"
      :prop="item.param"
      :sortable="item.sortable ? 'custom' : false"
      :show-overflow-tooltip="item.tooltip ? item.tooltip : false"
      :min-width="item.minWidth ? item.minWidth : null"
    >
      <template v-if="item.header ? item.header : false" slot="header">
        <slot :name="item.label"></slot>
      </template>
      <template v-if="item.headerSlot" #header>
        <slot :name="item.headerSlot" />
      </template>

      <template slot-scope="scope">
        <slot v-if="item.slot" :scope="scope" :name="item.slot"></slot>
        <div v-else-if="item.render" v-html="item.render(scope.row)"></div>
        <span v-else>{{ scope.row[item.param] }} {{ item.type }}</span>
      </template>
    </el-table-column>

    <el-table-column
      v-if="tableOption.label"
      :width="tableOption.width"
      :label="tableOption.label"
      align="center"
      class-name="small-padding fixed-width"
      :fixed="tableOption.fixed ? tableOption.fixed : false"
    >
      <template slot-scope="scope">
        <el-button
          v-for="(item, index) in tableOption.options"
          :key="index"
          v-permission="[item.permission]"
          :type="item.type"
          :disabled="item.disabled"
          :icon="item.icon"
          size="mini"
          @click="handleButton(item.methods, scope.row, scope.row)"
        >
          {{ tableOption.permission }}
        </el-button>
      </template>

      <template slot-scope="scope">
        <template v-if="tableOption.permission == '1'">
          <el-button
            v-for="(item, index) in tableOption.options"
            :key="index"
            v-permission="[item.permission]"
            :type="item.type"
            :icon="item.icon"
            :disabled="item.disabled"
            size="mini"
            @click="handleButton(item.methods, scope.row, scope.row)"
          >
            {{ item.label }}
          </el-button>
        </template>
        <template v-if="tableOption.permission == '0'">
          <el-button
            v-for="(item, index) in tableOption.options"
            :key="index"
            :type="item.type"
            :icon="item.icon"
            :disabled="item.disabled"
            size="mini"
            @click="handleButton(item.methods, scope.row, scope.row)"
          >
            {{ item.label }}
          </el-button>
        </template>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  components: {},
  props: {
    // 筛选框是否可选
    checkSelectable: {
      type: Function,
      default: () => {
        return Function;
      },
    },
    Height: {
      type: String,
      default: '',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    singleChoose: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableLabel: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableOption: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectionShow: {
      type: Boolean,
      default: false,
    },
    radioShow: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      type: String,
      default: '',
    },
    indexShow: {
      type: Boolean,
      default: false,
    },
    fixedIndex: {
      type: String,
      default: '',
    },
    maxHeight: {
      type: String,
      default: '',
    },
    reserveSelection: {
      type: Boolean,
      default: true,
    },
    handleIsSelection: {
      type: Function,
      default: () => {
        return {};
      },
    },
    // handleObjectSpanMethod: {
    //   type: Function,
    //   default: ({ row, column, rowIndex, columnIndex }) => {
    //     if (columnIndex === 2) {
    //       return { rowspan: 0, colspan: 0 };
    //     }
    //   },
    // },
    defaultSelect: {
      type: Boolean,
      default: false,
    },
    defaultSelectionArray: {
      type: Array,
      default() {
        return [];
      },
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true,
    },
    headerCellClassName: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      // 新增两个计算好的最终值，避免 undefined
      realHeight: undefined,
      realMaxHeight: undefined,
    };
  },
  watch: {
    defaultSelect: {
      handler(newVal) {
        if (newVal) {
          // 默认选中
          this.tableData.forEach((item) => {
            this.defaultSelectionArray.forEach((defaultArr) => {
              if (item[this.rowKey] == defaultArr) {
                this.$refs.table.toggleRowSelection(item);
              }
            });
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    // console.log(this.checkSelectable);
    // 在 mounted 阶段再赋值，确保 el-table 已拿到 $refs
    this.realHeight = this.Height || undefined;
    this.realMaxHeight = this.maxHeight || undefined;
  },
  methods: {
    handleCheckSelectable(row, index) {
      return this.checkSelectable(row);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.changeType == 2) {
        console.log(rowIndex);
        return 'warning-row';
      }
      return '';
    },
    handleButton(methods, row, index) {
      // 按钮事件
      this.$emit('handleButton', {
        methods,
        row,
        index,
      });
    },
    handleSortChange(val) {
      // 排序
      this.$emit('handleSortChange', val);
    },
    handleSelectionChange(val) {
      // 单选
      if (this.singleChoose && val.length > 1) {
        // 单选处理
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val[val.length - 1]);
      }
      this.$emit('handleSelectionChange', val);
    },
    handleSelect(rows, row) {
      this.$emit('handleSelect', {
        rows,
        row,
      });
    },
    // table滚动 设置最大高度
    bindMaxHeight() {
      if (this.maxHeight) {
        return { maxHeight: this.maxHeight };
      }
      return {};
    },
    handleSelectAll(val) {
      this.$emit('handleSelectAll', val);
    },
    handleRowClick(val) {
      this.$emit('handleRowClick', val);
    },
    handleToggleAllSelection() {
      this.$refs.table.toggleAllSelection();
    },
    // 清空选中
    handleClearSelection() {
      this.$refs.table.clearSelection();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table .warning-row {
  background-color: #f5f5f5;
  color: #999;
  border: 1px solid red;
}
</style>
